import get from 'lodash/get';
import { ShowButton, ShowButtonProps, useRecordContext } from 'react-admin';
export type ContextShowButtonProps = ShowButtonProps;

const ContextShowButton = (props: ContextShowButtonProps) => {
  const { label, ...rest } = props;
  const record = useRecordContext(props);
  if (!record) {
    return null;
  }
  const value = get(record, label!);
  return <ShowButton {...rest} label={value} />;
};

export default ContextShowButton;
